import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const promotionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addPromotion: builder.mutation<CommonResponseType & { data?: any }, any>({
      query: (body) => ({
        url: END_POINTS.promotions,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PROMOCODES"],
    }),
    updatePromotion: builder.mutation<
      CommonResponseType & { data?: any },
      { body: any }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.promotions}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["PROMOCODES"],
    }),
    getPromotionList: builder.query<
      CommonResponseType & {
        data: {
          RewardPromotions: any[];
          count: number;
        };
      },
      {
        page: number;
        limit: number;
        type?: number;
        status?: string;
        sort?: string;
        search?: string;
        dateFrom?: string;
        dateTo?: string;
        onlyRewardAndPromotion?: boolean;
      }
    >({
      query: ({
        page,
        limit,
        search,
        status,
        type,
        dateFrom,
        dateTo,
        sort,
        onlyRewardAndPromotion,
      }) => ({
        url:
          `${END_POINTS.promotions}/list/?page=${page}&limit=${limit}` +
          `${typeof type !== "undefined" ? `&type=${type}` : ""}` +
          `${search ? `&search=${search}` : ""}` +
          `${
            status !== "default"
              ? `&isActive=${status === "1" ? true : false}`
              : ""
          }` +
          `${dateFrom ? `&dateFrom=${dateFrom}` : ""}` +
          `${dateTo ? `&dateTo=${dateTo}` : ""}` +
          `${sort ? `&sortBy=createdAt&sortOrder=${sort}` : ""}` +
          `${
            onlyRewardAndPromotion
              ? `&onlyRewardAndPromotion=${onlyRewardAndPromotion}`
              : ""
          }`,
        method: "GET",
      }),
      providesTags: ["PROMOCODES"],
    }),
    getPromotionById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.promotions}/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, { id }) => [{ type: "PROMOCODES", id }],
    }),
    getPromotionReactionsById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.listReactions}/${id}`,
        method: "GET",
      }),
    }),
    deletePromotion: builder.mutation<
      CommonResponseType & { data?: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.promotions}/${id}`,
        method: "DELETE",
        body: {},
      }),
    }),
  }),
});

export const {
  useAddPromotionMutation,
  useUpdatePromotionMutation,
  useLazyGetPromotionListQuery,
  useGetPromotionByIdQuery,
  useLazyGetPromotionByIdQuery,
  useDeletePromotionMutation,
  useGetPromotionReactionsByIdQuery,
} = promotionsApi;
